import { supabase } from "./supabase";

const BASE_URL = "https://dm-backend-staging.up.railway.app/api/v1";

export class ApiManager {
  static async apiCall(endpoint, method = "GET", useToken = true, body = null) {
    const url = `${BASE_URL}${endpoint}`;
    const headers = {
      "Content-Type": "application/json",
      "x-client-type": "web",
    };

    if (useToken) {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      if (session) headers["Authorization"] = `Bearer ${session.access_token}`;
    }

    const options = {
      method,
      headers,
      body:
        method !== "GET" && method !== "DELETE" && body
          ? JSON.stringify(body)
          : undefined,
    };

    try {
      const response = await fetch(url, options);
      return await response.json();
    } catch (error) {
      return { success: false, message: "Network error" };
    }
  }

  static async signIn(payload) {
    const res = await ApiManager.apiCall(
      "/auth/signin",
      "POST",
      false,
      payload,
    );
    if (res.success) {
      await supabase.auth.setSession({
        access_token: res.data.access_token,
        refresh_token: res.data.refresh_token,
      });
    }
    return res;
  }

  static async signOut() {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    const res = await ApiManager.apiCall("/auth/signout", "POST", true, {
      refresh_token: session?.refresh_token || "",
    });
    await supabase.auth.signOut();
    return res;
  }

  //------------------------------------------------------------------
  static async getHolidays() {
    return ApiManager.apiCall("/holidays", "GET", true);
  }

  static async createHoliday(payload) {
    return ApiManager.apiCall("/holidays", "POST", true, payload);
  }

  static async updateHoliday(id, payload) {
    return ApiManager.apiCall(`/holidays/${id}`, "PATCH", true, payload);
  }

  static async deleteHoliday(id) {
    return ApiManager.apiCall(`/holidays/${id}`, "DELETE", true);
  }

  static async getUpcomingHolidays(limit = 3) {
    return ApiManager.apiCall(`/holidays/upcoming?limit=${limit}`, "GET", true);
  }
  //------------------software----------------------------

  static async getSoftwareAccess() {
    return ApiManager.apiCall("/software-access", "GET", true);
  }

  static async createSoftwareAccess(payload) {
    return ApiManager.apiCall("/software-access", "POST", true, payload);
  }

  static async updateSoftwareAccess(id, payload) {
    return ApiManager.apiCall(`/software-access/${id}`, "PATCH", true, payload);
  }

  static async deleteSoftwareAccess(id) {
    return ApiManager.apiCall(`/software-access/${id}`, "DELETE", true);
  }

  static async updateSoftwareEmployees(groupId, payload) {
    return ApiManager.apiCall(
      `/employee-software-access/software-access/${groupId}`,
      "PATCH",
      true,
      payload,
    );
  }
  static async getEmployeeSoftwareAccess() {
    return ApiManager.apiCall("/employee-software-access", "GET", true);
  }
  //----------------department ------------------
  static async getDepartments() {
    return ApiManager.apiCall("/departments", "GET", true);
  }

  static async createDepartment(payload) {
    return ApiManager.apiCall("/departments", "POST", true, payload);
  }

  static async updateDepartment(id, payload) {
    return ApiManager.apiCall(`/departments/${id}`, "PATCH", true, payload);
  }

  static async deleteDepartment(id) {
    return ApiManager.apiCall(`/departments/${id}`, "DELETE", true);
  }

  static async updateDeptEmployees(deptId, payload) {
    return ApiManager.apiCall(
      `/employee-departments/department/${deptId}`,
      "PATCH",
      true,
      payload,
    );
  }

  static async getEmployeeDepartments() {
    return ApiManager.apiCall("/employee-departments", "GET", true);
  }
  //----------------department ------------------

  static async getEmployees() {
    return ApiManager.apiCall("/employees", "GET", true);
  }

  static async createEmployee(payload) {
    // payload should include emp_name, emp_id, mobile, email, role, password,
    // date_of_joining, sick_leave, casual_leave, paid_leave, week_off
    return ApiManager.apiCall("/employees", "POST", true, payload);
  }

  static async updateEmployee(id, payload) {
    return ApiManager.apiCall(`/employees/${id}`, "PATCH", true, payload);
  }

  static async deleteEmployee(id) {
    return ApiManager.apiCall(`/employees/${id}`, "DELETE", true);
  }

  //------------------- signup
  static async signUp(payload) {
    return ApiManager.apiCall("/auth/signup", "POST", false, payload);
  }

  static async verifyOTP(payload) {
    return ApiManager.apiCall(
      "/auth/verify-otp",
      "POST",
      false,
      payload,
    );
  }
}
